<template>
  <div class="admin-home">
    <el-card class="welcome-card" shadow="never">
      <div class="welcome-title">众鑫驾校学习系统</div>
      <div class="welcome-desc">管理员控制台首页</div>
    </el-card>

    <el-row :gutter="20" class="overview-row">
      <el-col :span="8">
        <el-card shadow="hover" class="metric-card">
          <div class="metric-title">在线总人数</div>
          <div class="metric-value">{{ statistics.totalOnlineCount }}</div>
        </el-card>
      </el-col>

      <el-col :span="8">
        <el-card shadow="hover" class="metric-card">
          <div class="metric-title">在线管理员人数</div>
          <div class="metric-value">{{ statistics.adminOnlineCount }}</div>
        </el-card>
      </el-col>

      <el-col :span="8">
        <el-card shadow="hover" class="metric-card">
          <div class="metric-title">在线学员人数</div>
          <div class="metric-value">{{ statistics.studentOnlineCount }}</div>
        </el-card>
      </el-col>
    </el-row>

    <el-card class="trend-card" shadow="never">
      <div slot="header" class="trend-header">
        <span>今日每半小时在线人数趋势</span>
        <div class="trend-right">
          <span class="current-text">当前在线：{{ statistics.totalOnlineCount || 0 }}</span>
          <span class="max-text">今日峰值：{{ trendData.maxOnlineCount || 0 }}</span>
        </div>
      </div>
      <div ref="onlineTrendChart" class="trend-chart"></div>
    </el-card>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getOnlineStatistics } from '@/api/admin/student'
import { getTodayOnlineTrend } from '@/api/admin/home'

export default {
  name: 'AdminHome',
  data() {
    return {
      statistics: {
        totalOnlineCount: 0,
        adminOnlineCount: 0,
        studentOnlineCount: 0
      },
      trendData: {
        xList: [],
        yList: [],
        maxOnlineCount: 0
      },
      chartInstance: null
    }
  },
  created() {
    this.loadPageData()
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.chartInstance) {
      this.chartInstance.dispose()
      this.chartInstance = null
    }
  },
  methods: {
    async loadPageData() {
      await Promise.all([
        this.loadOnlineStatistics(),
        this.loadOnlineTrend()
      ])
    },

    async loadOnlineStatistics() {
      try {
        const res = await getOnlineStatistics()
        if (res.code === 200) {
          this.statistics = res.data || {
            totalOnlineCount: 0,
            adminOnlineCount: 0,
            studentOnlineCount: 0
          }
        }
      } catch (e) {
        console.log('获取在线统计失败', e)
      }
    },

    async loadOnlineTrend() {
      try {
        const res = await getTodayOnlineTrend()
        console.log('在线趋势接口返回：', res)

        if (res.code === 200) {
          const data = res.data || {}

          const rawXList = data.xList || data.xlist || []
          const rawYList = data.yList || data.ylist || []

          const now = new Date()
          const currentHour = now.getHours()
          const currentMinute = now.getMinutes()

          // 当前半小时桶索引
          const currentIndex = currentHour * 2 + (currentMinute >= 30 ? 1 : 0)

          // 未来时间改成 null，不画线
          const processedYList = rawYList.map((item, index) => {
            if (index > currentIndex) {
              return null
            }
            return item
          })

          this.trendData = {
            xList: rawXList,
            yList: processedYList,
            maxOnlineCount: data.maxOnlineCount || 0
          }

          this.$nextTick(() => {
            this.renderChart()
          })
        }
      } catch (e) {
        console.log('获取在线趋势失败', e)
      }
    },

    renderChart() {
      if (!this.$refs.onlineTrendChart) {
        return
      }

      if (!this.chartInstance) {
        this.chartInstance = echarts.init(this.$refs.onlineTrendChart)
      }

      const option = {
        color: ['#f56c6c'],
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: 60,
          right: 30,
          top: 40,
          bottom: 60
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.trendData.xList || [],
          axisLabel: {
            interval: 0,
            rotate: 45,
            formatter: function (value) {
              // 只显示整点，不显示 :30
              return value.endsWith(':00') ? value : ''
            }
          }
        },
        yAxis: {
          type: 'value',
          name: '在线人数',
          min: 0,
          minInterval: 1
        },
        series: [
          {
            name: '在线人数',
            type: 'line',
            smooth: false,
            connectNulls: false,
            showSymbol: true,
            symbol: 'circle',
            symbolSize: 8,
            data: this.trendData.yList || [],
            itemStyle: {
              color: '#f56c6c'
            },
            lineStyle: {
              width: 3,
              color: '#f56c6c'
            },
            areaStyle: {
              color: 'rgba(245,108,108,0.18)'
            }
          }
        ]
      }

      this.chartInstance.clear()
      this.chartInstance.setOption(option, true)
      this.chartInstance.resize()
    },

    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize()
      }
    }
  }
}
</script>

<style scoped>
.admin-home {
  width: 100%;
}

.welcome-card {
  margin-bottom: 20px;
  text-align: center;
}

.welcome-title {
  font-size: 28px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 10px;
}

.welcome-desc {
  font-size: 16px;
  color: #909399;
}

.overview-row {
  margin-bottom: 20px;
}

.metric-card {
  text-align: center;
}

.metric-title {
  font-size: 16px;
  color: #606266;
  margin-bottom: 12px;
}

.metric-value {
  font-size: 32px;
  font-weight: bold;
  color: #409EFF;
}

.trend-card {
  margin-bottom: 20px;
}

.trend-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.trend-right {
  display: flex;
  align-items: center;
  gap: 18px;
}

.current-text {
  color: #67c23a;
  font-size: 14px;
  font-weight: 500;
}

.max-text {
  color: #f56c6c;
  font-size: 14px;
  font-weight: 500;
}

.trend-chart {
  width: 100%;
  height: 420px;
}
</style>